import * as React from 'react';

export const IconRobot = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M12 .04a1.743 1.743 0 00-.537 3.401l-.631 2.579H2.456A2.456 2.456 0 000 8.476v13.029a2.456 2.456 0 002.456 2.456h19.088c1.356 0 2.456-1.1 2.456-2.456V8.476c0-1.356-1.1-2.456-2.456-2.456h-8.403l-.616-2.575A1.743 1.743 0 0011.999.04zM3.933 7.881h16.136c1.101 0 1.994.893 1.994 1.994v10.117a1.994 1.994 0 01-1.994 1.994H3.933a1.994 1.994 0 01-1.994-1.994V9.875c0-1.101.893-1.994 1.994-1.994zm3.254 2.312a4.575 4.575 0 100 9.15 4.575 4.575 0 000-9.15zm9.743 0a4.575 4.575 0 100 9.15 4.575 4.575 0 000-9.15zm-9.743 1.07a3.506 3.506 0 110 7.011 3.506 3.506 0 010-7.011zm9.743 0a3.506 3.506 0 110 7.011 3.506 3.506 0 010-7.011zm-9.743 1.663a1.843 1.843 0 100 3.686 1.843 1.843 0 000-3.686zm9.743 0a1.843 1.843 0 100 3.686 1.843 1.843 0 000-3.686zm-6.927 6.5v2.159h.706v-2.159h-.706zm1.077 0v2.159h.705v-2.159h-.705zm1.076 0v2.159h.706v-2.159h-.706zm1.077 0v2.159h.706v-2.159h-.706zm1.077.03v2.1a1.08 1.08 0 00.829-1.049v-.001c0-.51-.354-.937-.829-1.05zm-4.678.028a1.08 1.08 0 00-.731 1.021v.001c0 .474.306.876.731 1.021v-2.043z" />
    </svg>
  );
};
